import React from 'react'

import { Stack } from 'component-library-next'

import { UtilityBillCheck } from '@app/graphql/types'
import { useIntl } from '@app/intl/Intl'

type Props = {
  metadata: UtilityBillCheck
}

export const FormattedMetadata = ({ metadata }: Props) => {
  const { formatMessage } = useIntl()
  return (
    <Stack gap={Stack.gap.tiny}>
      <div>
        {formatMessage({ id: `PrintView.MessagesList.Metadata.MoveInDate` })}: {metadata.moveInDate}
      </div>
      {!metadata.isCurrentAddress && (
        <div>
          {formatMessage({ id: `PrintView.MessagesList.Metadata.MoveOutDate` })}:{' '}
          {metadata.moveOutDate}
        </div>
      )}
      <div>
        {formatMessage({ id: `PrintView.MessagesList.Metadata.SizeOfFlat` })}: {metadata.sizeOfFlat}
      </div>
    </Stack>
  )
}
